module.exports = __webpack_public_path__ + "img/business-2-community.dab21361.webp";